import React, { useState } from "react";
import { Box, TextField, Button, Grid, Link } from "@mui/material";
import "./Login.css";
import "../../common/Common.css";
import { customButtonStyles } from "../../common/commonStyles";
import logo from "../../assets/logo.svg";
import ReusableSnackbar from "../../shared/Alert/ReusableSnackbar";
import api from "../../services/api";

export default function ResetPassword() {
  const token = new URLSearchParams(window.location.search).get("token");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState({
    status: false,
    message: "",
    severity: "",
  });
  const handleClose = () => setSnackbarOpen(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      !password ||
      !confirmPassword ||
      password.trim() === "" ||
      confirmPassword.trim() === ""
    ) {
      setSnackbarOpen({
        status: true,
        message: "Fill all the required fields",
        severity: "error",
      });
      return;
    }

    if (password !== confirmPassword) {
      setSnackbarOpen({
        status: true,
        message: "Passwords do not match",
        severity: "error",
      });
      return;
    }

    try {
      await api.post(`app/reset-password`, {
        token: token,
        new_password: password,
      });
      setSnackbarOpen({
        status: true,
        message: "Password reset successful! You can now log in.",
      });
      setPassword("");
      setConfirmPassword("");
    } catch (error) {
      if (error.response) {
        setSnackbarOpen({
          status: true,
          message: error.response.data.detail || "Something went wrong",
          severity: "error",
        });
      } else if (error.request) {
        setSnackbarOpen({
          status: true,
          message: "No response from server. Please try again.",
          severity: "error",
        });
      } else {
        setSnackbarOpen({
          status: true,
          message: "Error: " + error.message,
          severity: "error",
        });
      }
    }
  };

  return (
    <>
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{ width: "100%", maxWidth: 400, mx: "auto" }}
          className="login-box"
        >
          <Box sx={{ textAlign: "center", mb: 2 }}>
            <img src={logo} alt="Logo" style={{ height: 30, maxHeight: 30 }} />
          </Box>
          <Box>
            <h3 className="login-text">Reset Your Password</h3>
            <h5 className="login_subtext">
              {" "}
              Time to set a new password 😊 Enter and confirm your new password
              below. Keep it strong and secure!
            </h5>
          </Box>
          <TextField
            type="password"
            required
            fullWidth
            label="Enter new password"
            id="fullWidth"
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="off"
            className="custom-textfield"
          />

          <TextField
            id="outlined-password-input"
            label="Confirm new password"
            type="password"
            autoComplete="off"
            required
            fullWidth
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            margin="normal"
            className="custom-textfield"
          />
          <Button
            variant="contained"
            fullWidth
            sx={customButtonStyles}
            onClick={handleSubmit}
          >
            Reset Password
          </Button>
          <Grid container spacing={2}>
            <Grid size={12} className="create_account">
              Back to{" "}
              <Link href="/" underline="none">
                Login
              </Link>
            </Grid>
          </Grid>
        </Box>
        
      </Box>

      <ReusableSnackbar
        open={snackbarOpen.status}
        message={snackbarOpen.message}
        onClose={handleClose}
        severity={snackbarOpen.severity}
      />
    </>
  );
}
